import { fetchFactory } from 'Libs/http/utils';
import { type DashboardBattlesFilters } from 'Pages/Analytics/Dashboard/Components/Battles/Battles';
import { type DashboardCampaignsFilters } from 'Pages/Analytics/Dashboard/Components/Campaigns/Campaigns';
import { type DashboardCoursesFilters } from 'Pages/Analytics/Dashboard/Components/Courses/Courses';

export const requestLiveActivityLeaderboard = (from: Date, to: Date) => {
  const fromDate = from.toISOString().split('T')[0];
  const toDate = to.toISOString().split('T')[0];
  const { fetchFn } = fetchFactory({
    route: `/api/exports/active-campaigns/leaderboard?fromDate=${fromDate}&toDate=${toDate}`,
    method: 'GET',
  });
  return fetchFn();
};

export const requestPlayerContentExport = (from: Date, to: Date) => {
  const fromDate = from.toISOString().split('T')[0];
  const toDate = to.toISOString().split('T')[0];
  const { fetchFn } = fetchFactory({
    route: `/api/exports/active-campaigns/player-contents?fromDate=${fromDate}&toDate=${toDate}`,
    method: 'GET',
  });
  return fetchFn();
};

export type CampaignsDashboardResponse = {
  url: string;
};

export const requestCampaignsDashboard = ({
  startDate,
  endDate,
  campaigns,
  audienceGroups,
}: DashboardCampaignsFilters): Promise<CampaignsDashboardResponse> => {
  const { fetchFn } = fetchFactory<CampaignsDashboardResponse>({
    route: `/api/analytics/back-office/dashboards/campaigns`,
    method: 'GET',
    query: {
      ...(startDate && { start_date: startDate.toISOString() }),
      ...(endDate && { end_date: endDate.toISOString() }),
      campaign_ids: campaigns?.toString(),
      audience_group_ids: audienceGroups?.toString(),
    },
  });
  return fetchFn();
};

export type CoursesDashboardResponse = {
  url: string;
};

export const requestCoursesDashboard = ({
  startDate,
  endDate,
  courses,
  audienceGroups,
}: DashboardCoursesFilters): Promise<CoursesDashboardResponse> => {
  const { fetchFn } = fetchFactory<CoursesDashboardResponse>({
    route: `/api/analytics/back-office/dashboards/courses`,
    method: 'GET',
    query: {
      ...(startDate && { start_date: startDate.toISOString() }),
      ...(endDate && { end_date: endDate.toISOString() }),
      course_ids: courses?.toString(),
      audience_group_ids: audienceGroups?.toString(),
    },
  });
  return fetchFn();
};

export type BattlesDashboardResponse = {
  url: string;
};

export const requestBattlesDashboard = ({
  startDate,
  endDate,
  audienceGroups,
}: DashboardBattlesFilters): Promise<BattlesDashboardResponse> => {
  const { fetchFn } = fetchFactory<BattlesDashboardResponse>({
    route: `/api/analytics/back-office/dashboards/battles`,
    method: 'GET',
    query: {
      ...(startDate && { start_date: startDate.toISOString() }),
      ...(endDate && { end_date: endDate.toISOString() }),
      audience_group_ids: audienceGroups?.toString(),
    },
  });
  return fetchFn();
};
